import Vue from "vue";
import Router from "vue-router";
import ChatContainer from "@/components/ChatContainer";
import TEST from "@/components/TEST/TEST";
import Notify from "@/components/Notify";
import Error from "@/components/Error";
import TextInfo from "@/components/TextInfo";
//import Main from "@/components/Main/Main";
import MainView from '../views/MainView.vue';
import ChatView from '../views/ChatView.vue';
import MainToolBbarStaff from '../../src/components/Main/MainToolBbarStaff.vue'
import MobileHomeView from '../../src/views/MobileHomeView.vue'
import MobileFriendGroupView from '../../src/views/MobileFriendGroupView.vue'
import MobileSalseQRCodePageView from '../../src/views/MobileSalseQRCodePageView.vue'
import MobileCreateLeadView from '../../src/views/MobileCreateLeadView.vue'
import MobileLeadInfoView from '../../src/views/MobileLeadInfoView.vue'
import MobileTackingLeadView from '../../src/views/MobileTackingLeadView.vue'
import MobileInvitationPageView from '../../src/views/MobileInvitationPageView.vue'
import MobileFriendListView from '../../src/views/MobileFriendListView.vue'
import MobileBindLeadAndSocialLeadView from '../../src/views/MobileBindLeadAndSocialLeadView.vue'
import MobileChangePasswordView from '../../src/views/MobileChangePasswordView.vue'
import MobilePriceListView from '../../src/views/MobilePriceListView.vue'
import Login from '../../src/views/Login.vue'
import MainMenu from '../../src/views/MainMenu.vue'
import Scrmlite from "@/components/scrmlite";
import SaleAgentNotifySetting from "../../src/views/SaleAgentNotifySetting.vue";
import MobileLeadListView from '../../src/views/MobileLeadListView.vue'
import MobilePotentialClientProfileView from '../../src/views/MobilePotentialClientProfileView.vue'

Vue.use(Router);

export default new Router({
  routes: [{
      path: "/TEST",
      name: "test",
      component: TEST
    },
    {
      path: "/scrmlite",
      name: "scrmlite",
      component: Scrmlite
    },

    {
      path: "/main2",
      name: "main2",
      component: MainView
    },
    // {
    //   path: "/",
    //   name: "notify",
    //   component: Notify
    // },
    {
      path: "/Chat",
      name: "chat",
      component: ChatContainer
    },
    {
      path: "/Chat2",
      name: "chat",
      component: ChatView
    },
    {
      path: "/MainChat",
      name: "chat",
      component: ChatContainer
    },

    {
      path: "/Error",
      name: "error",
      component: Error
    },
    {
      path: "/TextInfo",
      name: "TextInfo",
      component: TextInfo
    },
    {
      path: "/MobileLeadInfoView",
      name: "MobileLeadInfoView",
      component: MobileLeadInfoView
    },
    {
      path: "/MobileHomeView",
      name: "MobileHomeView",
      component: MobileHomeView
    },
    {
      path: "/MobileSalseQRCodePageView",
      name: "MobileSalseQRCodePageView",
      component: MobileSalseQRCodePageView
    },
    {
      path: "/MobileTackingLeadView",
      name: "MobileTackingLeadView",
      component: MobileTackingLeadView
    },
    {
      path: "/MobileInvitationPageView",
      name: "MobileInvitationPageView",
      component: MobileInvitationPageView
    },
    {
      path: "/MobileCreateLeadView",
      name: "MobileCreateLeadView",
      component: MobileCreateLeadView
    },
    {
      path: "/MobileFriendGroupView",
      name: "MobileFriendGroupView",
      component: MobileFriendGroupView
    },
    {
      path: "/MobileFriendListView",
      name: "MobileFriendListView",
      component: MobileFriendListView
    },
    //綁定一般名單與社群名單
    {
      path: "/MobileBindLeadAndSocialLeadView",
      name: "MobileBindLeadAndSocialLeadView",
      component: MobileBindLeadAndSocialLeadView
    },
    //價格表
    {
      path: "/MobilePriceListView",
      name: "MobilePriceListView",
      component: MobilePriceListView
    },
    //修改密碼
    {
      path: "/MobileChangePassword",
      name: "MobileChangePasswordView",
      component: MobileChangePasswordView
    },
    //登入
    {
      path: "/",
      name: "Login",
      component: Login
    },
    //登入
    {
      path: "/Login",
      name: "Login",
      component: Login
    },
    //手機版首頁
    {
      path: "/Main",
      name: "Main",
      component: MainMenu
    },
    //推廣大使LINE通知設定
    {
      path: "/SaleAgentNotifySetting",
      name: "SaleAgentNotifySetting",
      component: SaleAgentNotifySetting
    },
    //名單列表
    {
      path: "/MobileLeadListView",
      name: "MobileLeadListView",
      component: MobileLeadListView
    },
    //基本資料修改
    {
      path: "/MobilePotentialClientProfileView",
      name: "MobilePotentialClientProfileView",
      component: MobilePotentialClientProfileView
    },
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js